
import React from 'react';
import { Bot } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useIsMobile } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';
import { useNavigate } from 'react-router-dom';

const ChatBotButton = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  return (
    <Button 
      onClick={() => navigate('/chatbot')}
      className={cn(
        "fixed bottom-4 z-40",
        isMobile ? "right-4 h-10 w-10 rounded-full shadow-sm" : "right-5 h-12 w-12 rounded-full shadow-lg"
      )}
      size="icon"
      variant={isMobile ? "outline" : "default"}
      aria-label="Open chat assistant"
    >
      <Bot className={cn(
        isMobile ? "h-4 w-4" : "h-5 w-5"
      )} />
    </Button>
  );
};

export default ChatBotButton;
